export default __webpack_public_path__ + "static/13-b6bd9b3ec2e3cdfaa4e371b5e8cad75c.png";